import { create } from 'zustand';
import { persist, createJSONStorage, devtools } from 'zustand/middleware';


export const useStore = create(
	devtools(
		persist(
			(set, get) => ({
				collapsed: false,
				themeObj: {},

				updateTheme: (newTheme) =>
					set((state) => ({
						themeObj: { ...state.themeObj, ...newTheme },
					})),

				toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
			}),
			{
				name: 'storage',
				storage: createJSONStorage(() => localStorage),
			}
		)
	)
);
